<template>
	<div class="login">
		<h3>Warehouse Login</h3>
		<input
			name="username"
			class="textInput"
			placeholder="username"
			v-model="username"
		/>

		<br />

		<input
			class="textInput"
			placeholder="password"
			type="password"
			v-model="password"
			v-on:keyup.enter="submit"
		/>

		<br />

		<button @click.prevent="submit" class="loginButton">Login</button>
	</div>
</template>

<script>
export default {
	name: "Login",
	data: function() {
		return {
			username: null,
			password: null
		};
	},
	methods: {
		submit: async function() {
			if (this.username === null || this.password === null) {
				this.$buefy.toast.open({
					message: "Both fields are required",
					type: "is-danger",
					position: "is-top"
				});
			} else {
				this.userLogin();
			}
		},
		userLogin: async function() {
			const userLogin = await this.$api.login({
				username: this.username,
				password: this.password
			});
			if (userLogin) {
				this.$buefy.toast.open({
					message: "Login Successful!",
					type: "is-success",
					position: "is-top"
				});

				this.$axios.defaults.headers.common["Authorization"] =
					"Token " + userLogin.data.staffs_authToken;

				// Save in x
				this.$store.dispatch("set_auth", userLogin.data.staffs_authToken);

				this.$router.push("products");
			} else {
				// Display message if failed to login
				this.$buefy.toast.open({
					message: "Invalid Login",
					type: "is-danger",
					position: "is-top"
				});
			}
		}
	}
};
</script>

<style scoped>
.login {
	padding-top: 150px;
}

.login input {
	width: 200px;
	height: 40px;
	border: 1px solid #ccc;
	border-radius: 5px;
	margin-bottom: 10px;
	padding-left: 5px;
	font-size: 14px;
}

.loginButton {
	width: 210px;
	height: 50px;
	font-size: 16px;
	border-radius: 5px;
	border-width: 0;
	margin-top: 20px;
	background-color: #810369;
	color: white;
	cursor: pointer;
}

h3 {
	font-weight: bold;
	font-size: 20px;
	margin-bottom: 10px;
}
</style>
